import { SearchIcon, ThreeDotsMenuIcon } from 'Assets/icons/v2';
import { CstmPagination } from 'components/Common/Common';
import CommonButton from 'components/Common/CommonButton'
import ConfirmationPop from 'components/Modals/ConfirmationPop';
import ErrorComponent from 'components/shared/ErrorComponent';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import TableLayoutV2New from 'components/TableLayoutV2 New';
import { TASK_PLAN_TEMPLATES_ADD, TASK_PLAN_TEMPLATES_EDIT } from 'config/paths';
import { dateFormat, parseHtmlHelper } from 'helpers/common';
import { usePersistentState } from 'hooks/usePersistentState';
import { debounce } from 'lodash';
import React, { useCallback, useState } from 'react'
import { Col, Container, Dropdown, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDeleteTaskPlanTemplateMutation, useGetTaskPlanTemplatesQuery } from 'store/services/V2/TaskPlanTemplate';
import { taskPlanTemplateFilter } from 'store/slices/filter';

function TaskPlanTemplates() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);

    const [currentPage, setCurrentPage] = usePersistentState("school:page", 1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useSelector(state => state?.filter?.taskPlanTemplateFilter);
    const [deleteTaskPlanTemplate, { isLoading: deleteLoading }] = useDeleteTaskPlanTemplateMutation()
    const { data, isLoading, isError, isFetching } = useGetTaskPlanTemplatesQuery(
        { page: currentPage, limit: pageSize, ...filter }
    );
    const schoolClients = data?.records;
    const totalRecords = data?.total_records || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(taskPlanTemplateFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = useCallback(debounce((value) => {
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    const handleGetRowColor = (item) => {
        console.log('item ', item)
        if (item?.status == "discharged") {
            return "rowYellow";
        }
        else if (item?.status == "inactive") {
            return "rowGray";
        }
    }

    const column = [
        // {
        //   head: <div onClick={() => dispatch(schoolClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
        //   accessor: "is_favorite",
        //   isComponent: true,
        //   component: (item, ind) => (
        //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
        //   ),
        // },

        {
            head: "TASK",
            accessor: "task_title",
            isComponent: true,
            sorter: true,
            // width: "100%",
        },
        {
            head: "DESC",
            accessor: "description",
            isComponent: true,
            sorter: false,
            width: "100%",
            component: (item) => (
                <div>
                    {parseHtmlHelper(item?.description) || '-'}
                </div>
            )
        },
        {
            head: "DATE CREATED",
            accessor: "createdAt",
            isComponent: true,
            sorter: true,
            component: (item) => (
                <div className='d-flex justify-content-end'>
                    {dateFormat(item?.createdAt, "MMM DD, YYYY")}
                </div>
            )
        },

        {
            head: "STRATEGY",
            accessor: "strategy",
            headAlign: "right",
            isComponent: true,
            sorter: true,
            width: 110,
            component: (item) => (
                <div className='d-flex justify-content-end'>{item?.strategy?.length}</div>
            ),

        },

        {
            // head: "Action",
            accessor: "",
            isComponent: true,
            width: 70,
            component: (item, index) => (
                item?.status != "discharged" &&
                <Dropdown
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown.Toggle
                        variant="transparent"
                        className="p-0 border-0 text-dark w-100"
                        id="dropdown-basic"
                    >
                        <ThreeDotsMenuIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                        <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                            <h5 onClick={(e) => {

                                e.stopPropagation();
                                navigate(TASK_PLAN_TEMPLATES_EDIT.replace(":id", item.id));
                            }} className="cursor-pointer proxima mb-2">
                                Edit
                            </h5>
                            <h5 onClick={(e) => {

                                e.stopPropagation();
                                setCurrentEntry(item);
                                setShowModal(true);
                            }} className="cursor-pointer proxima mb-0">
                                Delete
                            </h5>

                        </ul>
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
    ];

    const handleDelete = async () => {
        try {
            setShowModal(false);
            const result = await deleteTaskPlanTemplate({ id: currentEntry?.id }).unwrap();
            if (!result?.error) successMessageToast(result?.data?.message);

        } catch (err) {
            console.error("error deleting template", err);
        };
    };
    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={handleDelete}
                type="delete"
            />

            <section className='client position-relative py-4'>
                <Container fluid>
                    {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> :
                        <Col lg="12" className="my-2">
                            <Row className='left classroom-conslutation d-flex justify-content-between align-items-end'>
                                <Col md="5">
                                    <h6 className="m-0  fw-bold main-head themeBlue">Task Plan Templates</h6>
                                </Col>
                                <Col md="7">
                                    <Row className='d-flex justify-content-end mt-2'>
                                        <Col xs="7">
                                            <div className="d-flex align-items-center gap-3 search-input-filter-v2 readonly-box">
                                                <input
                                                    onChange={(e) => handleSearchChange(e.target.value)}
                                                    className="border-0 shadow-none h-auto w-100"
                                                    placeholder="Type to search for a template"
                                                    defaultValue={filter?.search}
                                                    style={{ outline: "none" }}
                                                />
                                                <SearchIcon />
                                            </div>
                                        </Col>
                                        <Col xs="4" xl="3" className=' d-flex justify-content-center'>
                                            <CommonButton className="staff-button-filled" text="Create New" onClick={() => navigate(TASK_PLAN_TEMPLATES_ADD)} />
                                        </Col>

                                    </Row>
                                </Col>


                            </Row>

                            <div className="table-outer mt-3">

                                {isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || deleteLoading) && <LoadingOverlay />}
                                        <TableLayoutV2New
                                            data={schoolClients}
                                            column={column}
                                            filter={filter}
                                            url={TASK_PLAN_TEMPLATES_EDIT.replace("/:id", "")}
                                            handleSort={handleFilterChange("sort")}
                                            handleGetRowColor={handleGetRowColor}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    className={'paginationV2'}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    }
                </Container>


            </section>
        </>
    )
}

export default TaskPlanTemplates


